import CommandIdEnum from "../enums/CommandIdEnums";
import UserRightScopeEnum from "../enums/UserRightScopeEnum";
import UserRight from "../model/UserRight";
import { GbApiUserRightEnum } from "../enums/GbApiUserRightEnum";
import { hasGbApiRight } from "../store/userRightsStore";

const hasRequiredRights = (userRight: UserRight, commandId: CommandIdEnum): boolean => {
    switch (commandId) {
        case CommandIdEnum.AddLengthDimension:
        case CommandIdEnum.AddTextAnnotation:
        case CommandIdEnum.AddChecklistItem:
        case CommandIdEnum.AddAreaAnnotation:
        case CommandIdEnum.AddRectangleAnnotation:
        case CommandIdEnum.AddCircleAnnotation:
            return userRight.create;
        case CommandIdEnum.RemoveFromDocument:
        case CommandIdEnum.DeleteSceneObject:
            return userRight.delete != UserRightScopeEnum.NoRights;
        case CommandIdEnum.EditProperties:
        case CommandIdEnum.MoveSceneObjects:
            return userRight.update != UserRightScopeEnum.NoRights;
        // Clone creates a new scene object and then positions it, so it needs both rights.
        case CommandIdEnum.CloneSceneObjects:
            return userRight.create && userRight.update != UserRightScopeEnum.NoRights;
        // Read-only, so the document's rights don't matter; GB-API's bundles:browse:options:selection:read does
        case CommandIdEnum.BundleInspector:
            return hasGbApiRight(GbApiUserRightEnum.BundlesView);
        // Changes CoreAPI bundles, not the document
        case CommandIdEnum.DetachBundleElements:
            return hasGbApiRight(GbApiUserRightEnum.BundlesManage);
        default:
            return false;
    }   
};

export default hasRequiredRights;
